const state = {
  childComponentData: {},
  loading: false,
  node: {
    GuiNodeCh: []
  },
  totalItems: 0
};

const actions = {};

const getters = {};

const mutations = {
  SET_CHILD_COMPONENT_DATA(state, payload) {
    state.childComponentData = payload;
  },

  SET_NODE(state, payload) {
    state.node = payload.node;
    state.totalItems = Object.keys(payload.node.GuiNodeCh).length;
  }
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
